module.exports = __webpack_public_path__ + "img/kaarva_text.82eb8320.jpg";